import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';

// Set the base URL from the environment variable
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = Cookies.get('token');

// Async Thunks
export const addQuestion = createAsyncThunk(
  'chatbot/addQuestion',
  async (values, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/chatbot/add`, values, {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });
      console.log(response.data,"response.data")
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getFaqsAllData = createAsyncThunk(
  'chatbot/getFaqsAllData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/chatbot`, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAnswerByQuestion = createAsyncThunk(
  'chatbot/getAnswerByQuestion',
  async (question, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/chatbot/getAns`, { question }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteQuestion = createAsyncThunk(
  'chatbot/deleteQuestion',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${BASE_URL}/chatbot/${id}`, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStatus = createAsyncThunk(
  'chatbot/updateStatus',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${BASE_URL}/chatbot/${id}`);

      console.log(response.data,"-response.data--")
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);